import { createSlice } from '@reduxjs/toolkit';

export const issueSlice = createSlice({
    name: 'ISSUE',
    initialState: {
        loading: false,
        data: {},
        main_data: [],
        counts: {
            all: 0,
            open: 0,
            progress: 0,
            closed: 0,
            cancel: 0,
            reopen: 0,
        },
        error: false,
    },
    reducers: {
        ISSUE_FETCH_START: (state) => {
            state.loading = true;
        },
        ISSUE_FETCH_SUCCESS: (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.main_data = action.payload?.data ?? [];
            state.counts = action.payload?.counts ?? state.counts;
        },
        ADD_ISSUE_SUCCESS: (state, action) => {
            state.loading = false;
            state.main_data = [action.payload, ...state.main_data];
        },
        EDIT_ISSUE_SUCCESS: (state, action) => {
            state.loading = false;
            state.main_data = state.main_data.map((row) =>
                row.id === action.payload.id ? action.payload : row
            );
        },
        DELETE_ISSUE_SUCCESS: (state, action) => {
            state.loading = false;
            state.main_data = state.main_data.filter((row) => row.id !== action.payload);
        },
        ISSUE_FETCH_ERROR: (state) => {
            state.error = true;
            state.loading = false;
        },
    },
});

export const {
    ISSUE_FETCH_START,
    ISSUE_FETCH_SUCCESS,
    ADD_ISSUE_SUCCESS,
    EDIT_ISSUE_SUCCESS,
    DELETE_ISSUE_SUCCESS,
    ISSUE_FETCH_ERROR,
} = issueSlice.actions;

export default issueSlice.reducer;
